import Menu from './table/index';

export default Menu;
